import axios from '@axios'

export default {
  namespaced: true,
  state: {
    cartItemsCount: (() => {
      const userData = JSON.parse(localStorage.getItem('userData'))
      //console.log('userData',userData)
      //return 2;
      return userData && userData.extras ? userData.extras.eCommerceCartItemsCount : 0
    })(),
    
  },
  getters: {},
  mutations: {
    UPDATE_CART_ITEMS_COUNT(state, count) {
     
      let userData = JSON.parse(localStorage.getItem('userData'))
   

      state.cartItemsCount = count
      userData.cartItemsCount = count
       localStorage.setItem('userData', JSON.stringify(userData))
    },
  },
  actions: {
    addProductInCart(ctx,queryParams) {
      var data = JSON.stringify(queryParams);
      return new Promise((resolve, reject) => {
        axios
          .post('/property/v1/add-cart/', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeProductFromCart(ctx,{productId}){
       const userData = JSON.parse(localStorage.getItem('userData'))
       console.log(userData.id,productId)
      return new Promise((resolve, reject) => {
        axios
          .delete('/property/v1/cart/'+userData.id+'/'+productId)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    fetchCartProducts() {
       const userData = JSON.parse(localStorage.getItem('userData'))
      return new Promise((resolve, reject) => {
        axios
          .get('/property/v1/cart/'+userData.id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDeleteProperty(ctx, id){
      return new Promise((resolve, reject) => {
        axios
          .delete('/property/v1/delete/'+id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUpdateProperty(ctx, queryParams){
      var data = JSON.stringify(queryParams);
      
  
      return new Promise((resolve, reject) => {
        
          axios
          .post('property/v1/update_propertydate', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    fetchUpdatePropertyFolder(ctx, queryParams){
      var data = JSON.stringify(queryParams);
      return new Promise((resolve, reject) => {
        
        axios
        .post('property/v1/update_propertfolder', data)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })

    },
    
    fetchgetProperty(ctx,id){
      return new Promise((resolve, reject) => {
        axios
          .get('/property/v1/getdetail/'+id)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchgetActions(ctx,id){
      return new Promise((resolve, reject) => {
        axios
          .get('/property-action/v1/list')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProperties(ctx, queryParams){
      var data = JSON.stringify(queryParams);

      return new Promise((resolve, reject) => {
        axios
          .post('v2/property/filter', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchKeywordSuggestions(ctx, keyword) {
      return new Promise((resolve, reject) => {
        axios
          .post('property/v1/search-suggestions', { keyword })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTemplates(ctx, id ){
      return new Promise((resolve, reject) => {
        
          axios
          .get('property/v1/get_templates/'+id )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    fetchInvoices(ctx, queryParams) {
      
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/invoice/invoices', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInvoice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/invoice/invoices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchClients() {
      return new Promise((resolve, reject) => {
        axios
          .get('/apps/invoice/clients')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // addUser(ctx, userData) {
    //   return new Promise((resolve, reject) => {
    //     axios
    //       .post('/apps/user/users', { user: userData })
    //       .then(response => resolve(response))
    //       .catch(error => reject(error))
    //   })
    // },
    approvePropertyLists(ctx, data){
      return new Promise((resolve, reject) => {
          axios
          .post('/property/v1/request/approve-lists', data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })

    },
    facebookPost(ctx, id){
      return new Promise((resolve, reject) => {
        axios
          .get(`/v1/automate-post/page/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    truncateCart(ctx, userId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/property/v1/truncate-cart/${userId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
